import { Injectable, EventEmitter } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "../utility/http.client";

@Injectable()
export class TruckingService {
  refreshHeaderData: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpClient) {}

  createOrderUnload(data: any): Observable<any> {
    return this.http.post("/trucking/createOrderUnload", data);
  }
  fetchUnloadOrders(data: any): Observable<any> {
    return this.http.get("/trucking/fetchUnloadOrders", data);
  }
  updateOrderTrucking(data: any): Observable<any> {
    return this.http.post("/trucking/updateOrderTrucking", data);
  }

  sendTruckingOrderMail(data: any): Observable<any> {
    return this.http.post("/trucking/sendTruckingOrderMail", data);
  }
  markTruckingOrderField(data: any): Observable<any> {
    return this.http.post("/orders/markTruckingOrderField", data);
  }
  downloadTruckingOrderFile(data: any): Observable<any> {
    return this.http.getFile(
      "/trucking/downloadTruckingOrderFile" ,
      data
    );
  }
}
